import React from "react";
import PropTypes from "prop-types";

import IconButton from '@mui/material/IconButton';


import OpenInNewIcon from '@mui/icons-material/OpenInNew';




const ArticleWebLink = ({ reference }) => {
    

    return (
        <IconButton href={`https://www.foussier.fr/recherche?q=${reference}`} target="_blank" sx={{ p: 0 }}>
            <OpenInNewIcon fontSize='small' />
        </IconButton>
    );
}



ArticleWebLink.propTypes = {

};

ArticleWebLink.defaultProps = {

};

export default ArticleWebLink;


